webpackJsonp([228175288119410],{

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	var _StyledLink = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatenschutzerklaerungPage = function DatenschutzerklaerungPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Datenschutzerkl\xE4rung \u2022 ',
	        data.site.siteMetadata.title
	      )
	    ),
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _Typography.Title,
	        { fontSize: [4, 5], fontWeight: '7', lineHeight: 'title', mt: 0, mb: 3 },
	        'Datenschutzerkl\xE4rung'
	      ),
	      _react2.default.createElement(_Typography.Rule, { mt: 4, mb: 5 })
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 0, mb: 3 },
	        '1. Datenschutz auf einen Blick'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Allgemeine Hinweise'
	        ),
	        _react2.default.createElement('br', null),
	        'Die folgenden Hinweise geben einen einfachen \xDCberblick dar\xFCber, was mit Ihren personenbezogenen Daten passiert, wenn Sie meine Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xF6nlich identifiziert werden k\xF6nnen. Ausf\xFChrliche Informationen zum Thema Datenschutz entnehmen Sie meiner unter diesem Text aufgef\xFChrten Datenschutzerkl\xE4rung.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Datenerfassung auf meiner Website'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Wer ist verantwortlich f\xFCr die Datenerfassung auf dieser Website?'
	        ),
	        _react2.default.createElement('br', null),
	        'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten k\xF6nnen Sie dem Impressum dieser Website entnehmen.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Wie erfasse ich Ihre Daten?'
	        ),
	        _react2.default.createElement('br', null),
	        'Ihre Daten werden zum einen dadurch erhoben, dass Sie mir diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch beim Besuch der Website durch meine IT-Systeme erfasst. Das sind vor allem technische Daten wie z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs. Die Erfassung dieser Daten erfolgt automatisch, sobald Sie meine Website betreten.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Wof\xFCr nutze ich Ihre Daten?'
	        ),
	        _react2.default.createElement('br', null),
	        'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gew\xE4hrleisten. Andere Daten k\xF6nnen zur Analyse Ihres Nutzerverhaltens verwendet werden.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Welche Rechte haben Sie bez\xFCglich Ihrer Daten?'
	        ),
	        _react2.default.createElement('br', null),
	        'Sie haben jederzeit das Recht unentgeltlich Auskunft \xFCber Herkunft, Empf\xE4nger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben au\xDFerdem ein Recht, die Berichtigung, Sperrung oder L\xF6schung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k\xF6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an mich wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zust\xE4ndigen Aufsichtsbeh\xF6rde zu.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 0, mb: 3 },
	        '2. Allgemeine Hinweise und Pflichtinformationen'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Datenschutz'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Ich nehme den Schutz Ihrer pers\xF6nlichen Daten sehr ernst und behandele Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xE4rung.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xF6nlich identifiziert werden k\xF6nnen. Die vorliegende Datenschutzerkl\xE4rung erl\xE4utert, welche Daten ich erhebe und wof\xFCr ich sie nutze. Sie erl\xE4utert auch, wie und zu welchem Zweck das geschieht.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Ich weise darauf hin, dass die Daten\xFCbertragung im Internet wie z.B. bei der Kommunikation per E-Mail Sicherheitsl\xFCcken aufweisen kann. Ein l\xFCckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xF6glich.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Hinweis zur verantwortlichen Stelle'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Der Verantwortliche f\xFCr die Datenverarbeitung auf dieser Website ist:',
	        _react2.default.createElement('br', null),
	        'Dr. Lukas Pustina',
	        _react2.default.createElement('br', null),
	        'Kronenstra\xDFe 3',
	        _react2.default.createElement('br', null),
	        '53840 Troisdorf',
	        _react2.default.createElement('br', null),
	        'Deutschland',
	        _react2.default.createElement('br', null),
	        'Telefon: +49 2241 881 7597',
	        _react2.default.createElement('br', null),
	        'E-Mail: info@pustina.de',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Verantwortliche Stelle ist die nat\xFCrliche oder juristische Person, die allein oder gemeinsam mit anderen \xFCber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten wie z.B. Namen, E-Mail-Adressen etc. entscheidet.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Widerruf Ihrer Einwilligung zur Datenverarbeitung'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Viele Datenverarbeitungsvorg\xE4nge sind nur mit Ihrer ausdr\xFCcklichen Einwilligung m\xF6glich. Sie k\xF6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an mich. Die Rechtm\xE4\xDFigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xFChrt.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Beschwerderecht bei der zust\xE4ndigen Aufsichtsbeh\xF6rde'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Im Falle datenschutzrechtlicher Verst\xF6\xDFe steht dem Betroffenen ein Beschwerderecht bei der zust\xE4ndigen Aufsichtsbeh\xF6rde zu. Zust\xE4ndige Aufsichtsbeh\xF6rde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem ich wohne. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten k\xF6nnen folgendem Link entnommen werden:',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html',
	          text: 'https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html',
	          external: true
	        })
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Recht auf Daten\xFCbertragbarkeit'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Sie haben das Recht, Daten, die ich auf Grundlage Ihrer Einwilligung oder in Erf\xFCllung eines Vertrags automatisiert verarbeite, an sich oder an einen Dritten in einem g\xE4ngigen, maschinenlesbaren Format aush\xE4ndigen zu lassen. Sofern Sie die direkte \xDCbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'SSL- bzw. TLS-Verschl\xFCsselung'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Diese Seite nutzt aus Sicherheitsgr\xFCnden und zum Schutz der \xDCbertragung vertraulicher Inhalte, die Sie an mich als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschl\xFCsselung. Eine verschl\xFCsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von ',
	        _react2.default.createElement(
	          'i',
	          null,
	          'http://'
	        ),
	        ' auf',
	        ' ',
	        _react2.default.createElement(
	          'i',
	          null,
	          'https://'
	        ),
	        ' wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw. TLS-Verschl\xFCsselung aktiviert ist, k\xF6nnen die Daten, die Sie an mich \xFCbermitteln, nicht von Dritten mitgelesen werden.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Auskunft, Sperrung, L\xF6schung'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xFCber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xE4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder L\xF6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xF6nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an mich wenden.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 0, mb: 3 },
	        '3. Hosting'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Netlify'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Die Website wird vom Provider',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://www.netlify.com',
	          text: 'Netlify',
	          external: true
	        }),
	        ' ',
	        'gehostet. Ich habe mit Netlify einen Vertrag zur Auftragsverarbeitung (AVV) abgeschlossen.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Server Logs'
	        ),
	        _react2.default.createElement('br', null),
	        'Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server Logs, die Ihr Browser automatisch \xFCbermittelt. Dies sind: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage. Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenf\xFChrung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Ich behalte mir vor, diese Daten nachtr\xE4glich zu pr\xFCfen, wenn mir konkrete Anhaltspunkte fu\u0308r eine rechtswidrige Nutzung bekannt wird.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Quelle'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://www.e-recht24.de',
	          text: 'https://www.e-recht24.de',
	          external: true
	        })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = DatenschutzerklaerungPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-datenschutz-erklaerung-js-bc6a52cf7eedd8bd8276.js